import React from "react";
import SvgClose from "../../../../assets/icons/SvgClose";
import SvgLocation from "../../../../assets/icons/SvgLocation";
import { getCurrencySymbol } from "../../../../utils/getCurrencySymbol";
import { getLocationUrl } from "../../../../utils/getLocation";

export default function CountryDrawer({
  isOpen,
  setSelectedLocation,
  locations,
  setMainDrawer,
}) {
  return (
    <div
      className={`absolute left-0 right-0 top-0 transition-all bg-primary-500 ${
        isOpen ? "bottom-0" : "bottom-full"
      }`}
    >
      <div className="flex flex-col bg-primary-500">
        {isOpen && (
          <React.Fragment>
            <div
              role="button"
              className="flex justify-end hover:text-secondary-500 py-5 px-[30px] cursor-pointer"
              onClick={() => setMainDrawer("home")}
            >
              <SvgClose
                style={{
                  width: "12px",
                  height: "12px",
                  transform: "rotate(90deg)",
                }}
              />
            </div>
            <div className="flex flex-col mt-5 px-8 gap-y-5">
              {locations.map((location) => (
                <a
                  key={location.isoCode}
                  href={getLocationUrl(location.url)}
                  className="no-underline hover:text-secondary-500"
                >
                  <div className="flex items-center gap-x-4">
                    <SvgLocation
                      width="16px"
                      height="16px"
                      style={{ marginBottom: "4px" }}
                    />
                    <p
                      className="text-sm font-medium leading-6"
                      onClick={() => setSelectedLocation(location)}
                    >
                      {location.title}
                      &nbsp;
                      <span>
                        <span>
                          (
                          {`${location.currencyCode} 
                          ${getCurrencySymbol(
                            location.isoCode,
                            location.currencyCode
                          )}`}
                          )
                        </span>
                      </span>
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}
